import {authRequest} from './index.js'


export async function get_notification(notification_id){
  let data
  await authRequest.get(
    'notifications/' + notification_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_notifications(params = {}){
  let data
  await authRequest.get(
    'notifications',
    {
      params
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function create_notification(notification){
  let data
  await authRequest.post(
    '/notifications',
    { notification },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function update_notification(notification_id, notification){
  let data
  await authRequest.patch(
    '/notifications/' + notification_id,
    { notification },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function mark_as_seen(notification_id, notification){
  let data
  await authRequest.patch(
    '/notifications/' + notification_id,
    { notification },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}